export enum SumamoruProjectType {
  OGInternal = 'OGInternal', // OG域内
  CDE = 'CDE', // CDE
  KeiyouGas = 'KeiyouGas',
  SeibuGas = 'SeibuGas',
  NotSumamoru = 'NotSumamoru' // スマモルでない通常物件
}
